import {Component, OnInit} from '@angular/core';

@Component({
  selector: 'sb-modal-wrapper',
  templateUrl: './sb-modal-wrapper.component.html',
  styleUrls: ['./sb-modal-wrapper.component.scss'],
  standalone: false,
})
export class SbModalWrapperComponent implements OnInit {
  ngOnInit() {}

  constructor() {}
}
